import React from 'react';

/**
 * Icon — small inline SVG set tuned for Swadharma PRO surfaces.
 *
 *   <Icon name="search" />
 *   <Icon name="briefcase" size={20} stroke="var(--sw-saffron)" />
 *
 * All icons are 24×24 by default, single-stroke, and adopt currentColor so
 * they tint themselves to whatever the surrounding text colour is.
 */
const PATHS = {
    search:    <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    briefcase: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M3 13h18" /></>,
    users:     <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
    sparkle:   <><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" /></>,
    map:       <><path d="M9 4 3 7v13l6-3 6 3 6-3V4l-6 3-6-3z" /><path d="M9 4v13M15 7v13" /></>,
    spark:     <><path d="M12 2 14 9l7 2-7 2-2 7-2-7-7-2 7-2z" /></>,
    arrow:     <><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></>,
    check:     <><path d="m4 12 5 5L20 6" /></>,
    bookmark:  <><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" /></>,
    location:  <><path d="M12 22s8-7.5 8-13a8 8 0 1 0-16 0c0 5.5 8 13 8 13z" /><circle cx="12" cy="9" r="3" /></>,
    rupee:     <><path d="M6 4h12M6 9h12" /><path d="M14 18 6 14h2a5 5 0 0 0 0-10" /></>,
    calendar:  <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>,
    flame:     <><path d="M12 22c4 0 7-3 7-7 0-3-2-5-3-7-1 2-2 3-3 3-2-3-2-7-2-9-3 2-7 6-7 12 0 5 4 8 8 8z" /></>,
    shield:    <><path d="M12 3 4 6v6c0 5 4 8 8 9 4-1 8-4 8-9V6l-8-3z" /></>,
    globe:     <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>,
};

const Icon = ({
    name,
    size = 24,
    stroke = 'currentColor',
    strokeWidth = 1.6,
    fill = 'none',
    className = '',
    style = {},
    ...rest
}) => {
    const paths = PATHS[name];
    if (!paths) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`<Icon name="${name}" /> — unknown icon`);
        }
        return null;
    }
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={fill}
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`sw-icon ${className}`.trim()}
            style={style}
            aria-hidden="true"
            {...rest}
        >
            {paths}
        </svg>
    );
};

export default Icon;
